import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MailSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MailSVG;
